import Header from '../components/Header'
import Footer from '../components/Footer'

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="gradient-bg text-white py-16">
        <div className="container-max section-padding text-center">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-blue-100 text-lg">Last updated: January 2025</p>
        </div>
      </section>
      <section className="py-16">
        <div className="container-max section-padding max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed">We collect information you provide directly to us, such as when you create an account, submit a form, or contact us for support. This includes your name, email address, phone number, business details, and payment information.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">2. How We Use Your Information</h2>
              <p className="text-gray-600 leading-relaxed">We use the information we collect to provide, maintain, and improve our services, process transactions, send transactional and promotional communications, and comply with legal obligations.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">3. Information Sharing</h2>
              <p className="text-gray-600 leading-relaxed">We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our platform, subject to confidentiality agreements.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">We implement industry-standard security measures including SSL encryption, secure data storage, and regular security audits to protect your personal information from unauthorized access or disclosure.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Your Rights</h2>
              <p className="text-gray-600 leading-relaxed">You have the right to access, correct, or delete your personal data at any time. To exercise these rights, please contact us at <a href="mailto:support@mobipay.pk" className="text-orange-500 hover:underline">support@mobipay.pk</a>.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@mobipay.pk" className="text-orange-500 hover:underline">support@mobipay.pk</a> or call us at +92 343 8018055.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default PrivacyPolicyPage
